export default __webpack_public_path__ + "static/uni-wien-logo-gray-5333fbbc9361af196d1d2b43d49b4501.svg";